import React, {Component} from "react";
import {cx} from "../lib/ClassSet";
import "./Button.scss";

export default function ActionButton({label = "label", action = "submit", active = true, formButton = false, show = true, primary = true, onClick, style}) {

  if (!show) return null;
  let classes = cx({
    "Button": true,
    "ActionButton": true,
    "s-primary": primary,
    "s-secondary": !primary || label === "Cancel",
    "formButton": formButton,
    "s-active": active,
    "s-inactive": !active,
  })

  function handleClick(e) {
    if (active || e.shiftKey) {
      onClick(e);
    } else {
      e.stopPropagation();
      e.preventDefault();      
    }
  }


  let name = `${action}_button`;
  if (formButton) {
    return (
      <input className={classes} type="submit" name={name} value={label} style={style} />
    )
  } else {
    return (
      <div className={classes} onClick={handleClick} style={style}>
        <span className="label">{label}</span>
      </div> 
    )
  }
};